import React, { Component } from "react";
import { Row, Col, Table, Typography, notification, Tag, Card } from "antd";
import ModalItem from "../../../../Components/ModalItem";
import { ButtonItem } from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";

const { Title, Text } = Typography;

// Cliente puede ser persona física (nombre + apellidos) o moral (razón social)
const nombreCliente = (cliente) => {
  if (!cliente) return null;
  if (cliente.persona === false) {
    return cliente.razonSocial || cliente.nombreComercial || cliente.nombre || "-";
  }
  return `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim() || "-";
};

const nombreUsuario = (usuario) => {
  if (!usuario) return null;
  return `${usuario.nombre || ""} ${usuario.apellidoPaterno || ""} ${usuario.apellidoMaterno || ""}`.trim() || "-";
};

class ModalVerEvaluacion extends Component {
  state = {
    loading: false,
    evaluacion: null,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible && this.props.evaluacionId) {
      this.cargarDatos(this.props.evaluacionId);
    }
    if (prevProps.visible && !this.props.visible) {
      this.setState({ evaluacion: null });
    }
  }

  cargarDatos = (id) => {
    this.setState({ loading: true });
    axios
      .post("evaluacionesProveedor/datosEvaluacion", { id }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ evaluacion: res.data.evaluacion });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al cargar la evaluación." }))
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { visible, onCancel } = this.props;
    const { evaluacion } = this.state;
    const plantilla = evaluacion?.plantillaId;
    const resultado = evaluacion?.resultado;
    // Las columnas de la tabla de secciones cambian según el modo de puntuación
    const esPuntos = plantilla?.modoPuntuacion === "puntos";

    const columnasSeccion = esPuntos
      ? [
          { title: "Sección", dataIndex: "nombre" },
          {
            title: "Puntos obtenidos",
            dataIndex: "calificacion",
            render: (v) => (v === null || v === undefined ? "N/A" : v),
          },
          {
            title: "Puntos posibles",
            dataIndex: "totalPosible",
            render: (v) => v ?? "-",
          },
        ]
      : [
          { title: "Sección", dataIndex: "nombre" },
          {
            title: "Peso usado",
            dataIndex: "pesoEfectivo",
            render: (v) => (v == null ? "-" : `${v}%`),
          },
          {
            title: "Calificación",
            dataIndex: "calificacion",
            render: (v) => (v === null || v === undefined ? "N/A" : v),
          },
        ];

    const respuestasPorClave = {};
    (evaluacion?.respuestas || []).forEach((r) => {
      respuestasPorClave[`${r.seccionIndex}-${r.preguntaIndex}`] = r;
    });

    return (
      <ModalItem
        title={evaluacion ? `Evaluación: ${evaluacion.proveedorNombre}` : "Evaluación"}
        visible={visible}
        onCancel={onCancel}
        spinning={this.state.loading}
        width={800}
      >
        {evaluacion && (
          <div>
            <div
              style={{
                backgroundColor: "white",
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                padding: "12px 16px",
                marginBottom: 16,
              }}
            >
              <Row gutter={[16, 8]}>
                <Col span={12}>
                  <Text type="secondary" style={{ fontSize: 12, display: "block" }}>Proveedor</Text>
                  <Text strong>{evaluacion.proveedorNombre}</Text>
                </Col>
                <Col span={12}>
                  <Text type="secondary" style={{ fontSize: 12, display: "block" }}>Periodo</Text>
                  <Text strong>{evaluacion.periodo?.etiqueta || "-"}</Text>
                </Col>
                <Col span={12}>
                  <Text type="secondary" style={{ fontSize: 12, display: "block" }}>Plantilla</Text>
                  <Text>{evaluacion.plantillaNombre} (v{evaluacion.plantillaVersionNumero})</Text>
                </Col>
                <Col span={12}>
                  <Text type="secondary" style={{ fontSize: 12, display: "block" }}>Llenada</Text>
                  <Text>
                    {evaluacion.fechaLlenado ? moment(evaluacion.fechaLlenado).format("DD/MM/YYYY HH:mm") : "-"}
                  </Text>
                </Col>
                {evaluacion.clienteId && (
                  <Col span={12}>
                    <Text type="secondary" style={{ fontSize: 12, display: "block" }}>Cliente</Text>
                    <Text>{nombreCliente(evaluacion.clienteId)}</Text>
                  </Col>
                )}
                {evaluacion.responsableId && (
                  <Col span={12}>
                    <Text type="secondary" style={{ fontSize: 12, display: "block" }}>Responsable</Text>
                    <Text>{nombreUsuario(evaluacion.responsableId)}</Text>
                  </Col>
                )}
              </Row>
            </div>

            {resultado && (
              <div
                style={{
                  padding: 16,
                  borderRadius: 8,
                  backgroundColor: "#fafafa",
                  border: "1px solid #f0f0f0",
                  marginBottom: 16,
                }}
              >
                <Row align="middle" gutter={16}>
                  <Col>
                    <Title level={2} style={{ margin: 0 }}>
                      {resultado.calificacionFinal ?? "-"}
                      {resultado.totalPosible != null && (
                        <Text type="secondary" style={{ fontSize: 18, fontWeight: "normal" }}>
                          {" "}
                          / {resultado.totalPosible}
                        </Text>
                      )}
                    </Title>
                  </Col>
                  <Col>
                    <Tag color={resultado.clasificacionColor || "default"} style={{ fontSize: 13 }}>
                      {resultado.clasificacion}
                    </Tag>
                  </Col>
                </Row>

                <Table
                  style={{ marginTop: 12 }}
                  size="small"
                  pagination={false}
                  rowKey="nombre"
                  columns={columnasSeccion}
                  dataSource={resultado.porSeccion || []}
                />
              </div>
            )}

            <Title level={5} style={{ marginBottom: 12 }}>Respuestas</Title>

            {(plantilla?.secciones || []).map((seccion, seccionIndex) => (
              <Card
                key={seccionIndex}
                size="small"
                title={seccion.nombre}
                style={{ marginBottom: 12 }}
              >
                {(seccion.preguntas || []).map((pregunta, preguntaIndex) => {
                  const r = respuestasPorClave[`${seccionIndex}-${preguntaIndex}`];
                  const sinRespuesta = r?.puntosObtenidos === null || r?.puntosObtenidos === undefined;
                  return (
                    <Row
                      key={preguntaIndex}
                      align="middle"
                      style={{ padding: "8px 0", borderBottom: "1px solid #f5f5f5" }}
                    >
                      <Col span={13}>
                        <Text>{pregunta.descripcion}</Text>
                        {pregunta.textoAyuda && (
                          <div>
                            <Text type="secondary" style={{ fontSize: 11 }}>
                              {pregunta.textoAyuda}
                            </Text>
                          </div>
                        )}
                      </Col>
                      <Col span={7}>
                        <Text type={r?.noAplica ? "secondary" : undefined}>
                          {r?.noAplica
                            ? "No aplica"
                            : r?.valorOpcion?.etiqueta ??
                              r?.valorTexto ??
                              (r?.valorBol !== undefined ? (r.valorBol ? "Sí" : "No") : r?.valorNum) ??
                              "-"}
                        </Text>
                      </Col>
                      <Col span={4} style={{ textAlign: "right" }}>
                        {!sinRespuesta && (
                          <Tag color="blue">{r.puntosObtenidos} pts</Tag>
                        )}
                      </Col>
                    </Row>
                  );
                })}
              </Card>
            ))}

            {evaluacion.observacionesGenerales && (
              <Card size="small" title="Observaciones Generales" style={{ marginBottom: 12 }}>
                <Text>{evaluacion.observacionesGenerales}</Text>
              </Card>
            )}
          </div>
        )}

        <div style={{ textAlign: "right", marginTop: 20, marginBottom: 2 }}>
          <ButtonItem onClick={onCancel}>Cerrar</ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalVerEvaluacion);
